import React, { useState } from 'react';
import { supabase } from '../lib/supabase';
import { generateResetToken, validateEmail } from '../utils/auth';
import { useLanguage } from '../context/LanguageContext';

const F = "'Plus Jakarta Sans',sans-serif";
const inp = { width:'100%', background:'#f8f9fb', border:'1px solid #e8edf5', borderRadius:10, padding:'12px 14px', color:'#1a2233', fontSize:15, fontFamily:F, outline:'none', marginBottom:12, minHeight:48, boxSizing:'border-box' };
const btn = { width:'100%', border:'none', padding:'13px', borderRadius:10, fontSize:14, fontWeight:700, cursor:'pointer', fontFamily:F, display:'flex', alignItems:'center', justifyContent:'center', gap:8, minHeight:50 };

const WA_NUM = '201008182425';

export default function ForgotPassword({ onBack }) {
  const { t } = useLanguage();
  const [email,    setEmail]    = useState('');
  const [loading,  setLoading]  = useState(false);
  const [error,    setError]    = useState('');
  const [sent,     setSent]     = useState(false);

  async function handleSubmit() {
    setError('');
    if (!validateEmail(email)) { setError(t('invalidEmail')); return; }

    setLoading(true);
    try {
      const emailLower = email.trim().toLowerCase();
      const token      = generateResetToken();
      const expires    = new Date(Date.now() + 24 * 3600 * 1000).toISOString(); // 24h

      // Try students table first, then teachers
      const { data: student } = await supabase
        .from('students').select('id').eq('email', emailLower).maybeSingle();

      if (student) {
        await supabase.from('students').update({
          reset_token:         token,
          reset_token_expires: expires,
        }).eq('id', student.id);
      } else {
        const { data: teacher } = await supabase
          .from('teachers').select('id').eq('email', emailLower).maybeSingle();
        if (teacher) {
          await supabase.from('teachers').update({
            reset_token:         token,
            reset_token_expires: expires,
          }).eq('id', teacher.id);
        }
      }

      // Always show success (don't reveal if email exists)
      setSent(true);
    } catch {
      setError(t('connectionError'));
    } finally { setLoading(false); }
  }

  if (sent) {
    return (
      <div style={{ minHeight:'100vh', background:'linear-gradient(160deg,#f8f9fb,#eef2f9)', display:'flex', alignItems:'center', justifyContent:'center', padding:'20px 16px' }}>
        <div style={{ width:'100%', maxWidth:420 }}>
          <div style={{ background:'#fff', border:'1px solid #e8edf5', borderRadius:18, padding:'32px 24px', boxShadow:'0 4px 28px rgba(26,42,74,0.10)', textAlign:'center' }}>
            <div style={{ fontSize:48, marginBottom:14 }}>📩</div>
            <div style={{ fontFamily:"'Cormorant Garamond',serif", fontSize:22, fontWeight:700, color:'#1a2a4a', marginBottom:10 }}>
              Request Received
            </div>
            <div style={{ fontSize:13, color:'#5a6a88', lineHeight:1.7, marginBottom:22 }}>
              If <strong>{email}</strong> is registered, a reset request has been logged.<br/><br/>
              Please contact Mr. Ahmed Salem on WhatsApp to verify your identity and complete the reset.
            </div>
            <a href={`https://wa.me/${WA_NUM}?text=${encodeURIComponent('I need to reset my password for IELTS Compass. My email: ' + email)}`}
              target="_blank" rel="noreferrer"
              style={{ display:'flex', alignItems:'center', justifyContent:'center', gap:8, background:'#25d366', color:'#fff', borderRadius:10, padding:'13px', fontSize:14, fontWeight:700, textDecoration:'none', marginBottom:16, fontFamily:F }}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
              Contact Mr. Ahmed Salem →
            </a>
            <button onClick={onBack}
              style={{ background:'none', border:'none', color:'#9aa3b8', fontSize:12, cursor:'pointer', fontFamily:"'JetBrains Mono',monospace" }}>
              ← Back
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={{ minHeight:'100vh', background:'linear-gradient(160deg,#f8f9fb,#eef2f9)', display:'flex', alignItems:'center', justifyContent:'center', padding:'20px 16px' }}>
      <div style={{ width:'100%', maxWidth:420 }}>
        <div style={{ textAlign:'center', marginBottom:24 }}>
          <img src="/logo.png" alt="IELTS Compass" style={{ height:52, objectFit:'contain' }}/>
        </div>
        <div style={{ background:'#fff', border:'1px solid #e8edf5', borderRadius:18, padding:'32px 24px', boxShadow:'0 4px 28px rgba(26,42,74,0.10)' }}>
          <div style={{ fontFamily:"'Cormorant Garamond',serif", fontSize:24, fontWeight:700, color:'#1a2a4a', marginBottom:6 }}>
            {t('forgotPassword')}
          </div>
          <div style={{ fontSize:13, color:'#5a6a88', marginBottom:22, lineHeight:1.65 }}>
            Enter your email address and we'll log your reset request. Mr. Ahmed Salem will help you reset your password via WhatsApp.
          </div>

          <div style={{ fontFamily:"'JetBrains Mono',monospace", fontSize:10, letterSpacing:'.14em', textTransform:'uppercase', color:'#9aa3b8', marginBottom:6 }}>
            {t('emailAddress')}
          </div>
          <input type="email" value={email} onChange={e=>setEmail(e.target.value)}
            onKeyDown={e=>e.key==='Enter'&&handleSubmit()}
            placeholder="yourname@email.com" style={inp} autoFocus/>

          {error && (
            <div style={{ color:'#c0392b', fontSize:12.5, marginBottom:12, padding:'9px 12px', background:'#fff5f5', borderRadius:8, border:'1px solid rgba(192,57,43,0.2)' }}>
              {error}
            </div>
          )}

          <button onClick={handleSubmit} disabled={loading}
            style={{ ...btn, background:'linear-gradient(135deg,#1a2a4a,#2a3a5a)', color:'#fff', boxShadow:'0 3px 12px rgba(26,42,74,0.25)', marginBottom:14, opacity:loading?0.7:1 }}>
            {loading ? 'Please wait…' : 'Reset Password via WhatsApp →'}
          </button>

          <div style={{ textAlign:'center' }}>
            <button onClick={onBack}
              style={{ background:'none', border:'none', color:'#9aa3b8', fontSize:12, cursor:'pointer', fontFamily:"'JetBrains Mono',monospace" }}>
              ← Back
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
